export const SVNS_EVENTS_2026 = [
  {
    name: "Hong Kong",
    leagueId: null,
    status: "completed",
  },

  {
    name: "Valladolid",
    leagueId: 130,
    status: "live",
  },

  {
    name: "Bordeaux",
    leagueId: null,
    status: "coming-soon",
  },
];